import {Box, Button, Grid, TextField} from "@mui/material"
import {useState} from "react"

export default function PropertyComplexBar() {
    const [search, setSearch] = useState("")

    function handleChange(e) {
        setSearch(e.target.value)
    }

    return (
        <Grid
            container
            sx={{
                display: "flex",
                flexDirection: "row",
                flexWrap: {lg: "nowrap", md: "wrap"},
                justifyContent: {md: "space-between", xs: "space-between"},
                width: "100%",
                maxHeight: {xs: "100%", md: "fit-content", lg: "75px"},
                backgroundColor: "#fff",
                padding: {md: "1vh", xs: "1vh"},
                borderRadius: "1vh",
                margin: "20px auto",
                boxShadow: "0 4px 5px 0 rgba(0,0,0,0.5)",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: {xl: "row", xs: "column"},
                    justifyContent: {md: "space-between", xs: "center"},
                    alignItems: "center",
                    width: {lg: "33.3%", md: "50%", sm: "100%"},
                }}
                component="form"
            >
                <TextField
                    id="outlined-basic"
                    label="Search Complexes"
                    variant="outlined"
                    value={search}
                    sx={{margin: "5px auto", fontSize: "12px", width: "100%"}}
                    onChange={handleChange}
                />
            </Box>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: {xl: "row", xs: "column"},
                    justifyContent: {md: "flex-end", xs: "center"},
                    alignItems: "center",
                    width: {md: "50%", xs: "100%"},
                    padding: "10px",
                }}
            >
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: "#037171",
                        color: "#fff",
                        "&:hover": {
                            backgroundColor: "#FFF",
                            color: "#037171",
                        },
                        fontSize: "12px",
                        padding: "5px 7px",
                        margin: {xs: "10px 0", md: "5px auto", lg: "0 "},
                        textTransform: "full-width",
                        width: {xs: "100%", lg: "50%"},
                    }}
                >
                    Add Complex
                </Button>
            </Box>
        </Grid>
    )
}
